// Keep IDs as-is (these never change across languages)
export const ORDER = [
  "Welcome-to-Noty-Universe",
  "Who-Created-This-Universe",
  "Why-Was-This-Universe-Created",
  "Who-Funds-This-Universe",
  "Free-Thinkers-And-Different-Minds",
  "Becoming-a-Citizen",
  "Privacy-And-Trust",
  "The-Noty-Spirit",
];

// Helper to build the translation key for each item
export const titleKey = (id) => `about.menu.${id}`;

// (Optional) convenience helpers you already have:
export const nextOf = (id) => ORDER[ORDER.indexOf(id) + 1] || null;
export const prevOf = (id) => ORDER[ORDER.indexOf(id) - 1] || null;
